import './style.scss'

import React, { JSX, useState } from 'react'

import ArrowIcon from '~/assets/images/icons/right-arrow.svg?react'
import { GOOGLE_EVENTS, sendGoogleGoal } from '~/libs/analytic/ga'
import {
    MobileCtaVariant,
    resolveMobileCtaVariant,
    useStoredAdsCtaVariant,
} from '~/libs/mobileCta'

import { ButtonColor } from '../../../../components/buttons/buttonColor'
import startImg from '../../assets/img/how-start-desktop.png'
import startImgMobile from '../../assets/img/how-start-mobile.png'

type Props = {
    openModal: () => void
    url?: string
}

enum TAB_TYPES {
    OPERATOR,
    BROKER
}

export function SectionJoin({ openModal, url }: Props): JSX.Element {
    const adsCtaVariant = useStoredAdsCtaVariant(resolveMobileCtaVariant(url))
    const isColorAdsCta = adsCtaVariant === MobileCtaVariant.start_free_ads_color

    const [active, setActive] = useState<TAB_TYPES.BROKER | TAB_TYPES.OPERATOR>(TAB_TYPES.BROKER)

    const handleStartFree = () => {
        sendGoogleGoal(GOOGLE_EVENTS.start_free_bottom)
        openModal()
    }

    const stepOperator = [
        {
            title: 'Register and get verified',
            text: 'Create your company profile with fleet, routes and commercial preferences. Our team reviews and activates your account.',
        },
        {
            title: 'Publish capacity and receive requests',
            text: 'Add available aircraft and empty legs. Receive targeted charter requests from verified forwarders in real time — no cold emails.',
        },
        {
            title: 'Respond with offers and close deals',
            text: 'Send customized quotes directly through the platform. You have total control over your pricing, fleet visibility, and the information you choose to share.',
        },
    ]

    const stepBroker = [
        {
            title: 'Enter your cargo details',
            text: 'Create a free account and tell us who you are: forwarder, broker, shipper, airline, or aircraft operator.',
        },
        {
            title: 'Receive offers from verified operators',
            text: 'The platform sends your request to matching operators. Compare aircraft, prices and availability in one place to respond to your client faster.',
        },
        {
            title: 'Confirm and coordinate online',
            text: 'Choose an operator, confirm details via built-in chat and exchange documents in one workspace. Contact operators directly with no platform commission.',
        },
    ]

    const currentStep = active === TAB_TYPES.BROKER ? stepBroker : stepOperator

    return (
        <section className="section section-join" id="anchor-join">
            <div className="container section-join__container">
                <div className="section-join__start">
                    <div className="section-join__top">
                        <div className="section-join__section-title">
                            / How it works
                        </div>
                        <div className="section-join__block-title">
                            <h2 className="section-join__title">
                                Get started in 3 simple steps
                            </h2>

                            <div className="section-join__tabs">
                                <div className="section-join__tabs-list">
                                    <div
                                        className={`section-join__tab ${active === TAB_TYPES.BROKER ? 'section-join__tab-active' : ''}`}
                                        onClick={() => setActive(TAB_TYPES.BROKER)}
                                    >
                                        I need aircraft
                                    </div>
                                    <div
                                        className={`section-join__tab ${active === TAB_TYPES.OPERATOR ? 'section-join__tab-active' : ''}`}
                                        onClick={() => setActive(TAB_TYPES.OPERATOR)}
                                    >
                                        I have capacity
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="section-join__wrap">
                        <div className="section-join__start__img">
                            <img
                                alt="How to submit a cargo charter request"
                                src={startImg}
                                width={1734}
                                height={115}
                                loading="lazy"
                                decoding="async"
                            />
                        </div>
                        <div className="section-join__start__img-mobile">
                            <img
                                src={startImgMobile}
                                alt=""
                                width={64}
                                height={342}
                                loading="lazy"
                                decoding="async"
                            />
                        </div>
                        <div className="section-join__start-list">
                            <div className="section-join__start-list-item">
                                <div className="section-join__start__title">{currentStep[0].title}</div>
                                <div className="section-join__start__text">
                                    {currentStep[0].text}
                                </div>
                            </div>
                            <div className="section-join__start-list-item">
                                <div className="section-join__start__title">{currentStep[1].title}</div>
                                <div className="section-join__start__text">
                                    {currentStep[1].text}
                                </div>
                            </div>
                            <div className="section-join__start-list-item">
                                <div className="section-join__start__title">{currentStep[2].title}</div>
                                <div className="section-join__start__text">
                                    {currentStep[2].text}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-join__block-button">
                    <ButtonColor
                        modClass="start-button"
                        text="Get start free"
                        onClick={handleStartFree}
                        blue={isColorAdsCta}
                        orange={!isColorAdsCta}
                        SvgIcon={ArrowIcon}
                    />
                </div>
            </div>
        </section>
    )
}
